import * as Scrivito from "scrivito"

import { PimContentWidget } from "./PimContentWidgetClass"

Scrivito.provideComponent(PimContentWidget, ({ widget }) => (
  <div className="pim-content-widget">
    <div>
      <strong>Überschrift: </strong>
      <Scrivito.ContentTag tag="p" content={widget} attribute="label" />
    </div>
    <div>
      <strong>Feldname: </strong>
      <Scrivito.ContentTag tag="p" content={widget} attribute="name" />
    </div>
    <div>
      <strong>Inhalt: </strong>
      <Scrivito.ContentTag tag="p" content={widget} attribute="text" />
    </div>
    <hr />
  </div>
))
